import { Controller } from "@hotwired/stimulus"
import { marked } from "marked"
import DOMPurify from "dompurify"

export default class extends Controller {
  static targets = ["source", "output"]

  connect() {
    marked.setOptions({
      breaks: true,
      gfm: true
    })

    this.render()
    this.setupObserver()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  setupObserver() {
    this.observer = new MutationObserver(() => this.render())

    if (this.hasSourceTarget) {
      this.observer.observe(this.sourceTarget, {
        childList: true,
        subtree: true,
        characterData: true
      })
    }
  }

  render() {
    if (!this.hasSourceTarget || !this.hasOutputTarget) return

    const raw = this.sourceTarget.textContent || ""
    if (raw.trim().length === 0) return

    // Strip sentinel config blocks (e.g. [INTEGRATION_CONFIG]...[/INTEGRATION_CONFIG])
    // before rendering markdown so users see clean prose
    const cleaned = raw.replace(/\[([A-Z_]+)\][\s\S]*?\[\/\1\]/g, '')
    // marked does not sanitize — model output can carry raw HTML
    // (<script>, <img onerror>), so sanitize before the innerHTML sink
    this.outputTarget.innerHTML = DOMPurify.sanitize(marked.parse(cleaned))
  }
}
